import React from 'react';
import type {UserType} from 'api/generated';
import {getInitials} from 'utils';
import {Avatar} from 'components';
import {format} from 'date-fns';

interface IUserItemProps {
  user: UserType;
}

const UserItem = ({user}: IUserItemProps) => {
  return (
    <div className="flex gap-3 items-center">
      <Avatar imageUrl={user.imageUrl} alt={user.handle} fallback={getInitials(user.name)} size="small" />
      <div className="flex flex-col gap-1">
        <p className="dark:text-white text-sm">{user.name}</p>
        <p className="dark:text-darkText text-xs">{user.lastActiveAt ? `Online: ${format(new Date(user.lastActiveAt), 'dd MMM y')}` : 'Offline'}</p>
      </div>
    </div>
  );
};

export default React.memo(UserItem);
